import axios from 'axios';

import { env } from 'config';
import { TelegramUser } from 'types';

import { createCrudApi } from './crud.api';

const login = async (id: string) =>
  (await axios.post(`${env.apiUrl}/telegram-users/${id}/login`)).data;

const logout = async (id: string) =>
  (await axios.post(`${env.apiUrl}/telegram-users/${id}/logout`)).data;

const signIn = async ({ id, data }: { id: string; data: { code: string } }) =>
  (await axios.post(`${env.apiUrl}/telegram-users/${id}/sign-in`, data)).data;

const checkChatMembership = async ({
  userId,
  chatId,
}: {
  userId: string;
  chatId: number;
}): Promise<{ isInChat: boolean }> =>
  (
    await axios.post(
      `${env.apiUrl}/telegram-users/${userId}/check-chat-membership`,
      { chatId },
    )
  ).data;

export const telegramUsersApi = {
  ...createCrudApi<TelegramUser>('/telegram-users'),
  login,
  logout,
  signIn,
  checkChatMembership,
};
